import { SET_OTHER_PERMISSIONS } from './types';

export const setOtherPermissions = (otherPermissions: unknown) => ({
  type: SET_OTHER_PERMISSIONS,
  otherPermissions,
});
